import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const images = [
  '/Showcase/showcase1.png',
  '/Showcase/showcase2.png',
  '/Showcase/showcase3.png',
  '/Showcase/showcase4.png',
  '/Showcase/showcase5.png',
  '/Showcase/showcase6.png',
  '/Showcase/showcase7.png'
];

const Showcase = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = useCallback(() => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  }, [currentIndex]);

  const nextSlide = useCallback(() => {
    const isLastSlide = currentIndex === images.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  }, [currentIndex]);

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  // Auto-advance slides
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <section className="py-20 bg-gray-50" id="showcase">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center bg-purple-50 rounded-full px-4 py-2 mb-4">
            <span className="text-purple-600 font-semibold text-sm uppercase tracking-wider">App Showcase</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0C1D40] mb-6">
            Experience Tifl in Action
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Explore the features designed to support your parenting journey.
          </p>
        </div>

        {/* Carousel Container */}
        <div className="max-w-4xl mx-auto relative group">
          <div className="w-full h-[600px] md:h-[700px] flex items-center justify-center bg-transparent rounded-3xl p-4">
            {/* Image */}
            <div className="relative w-full h-full flex items-center justify-center">
                <img 
                  src={images[currentIndex]} 
                  alt={`Tifl App Screenshot ${currentIndex + 1}`} 
                  className="max-h-full max-w-full object-contain drop-shadow-2xl rounded-2xl transition-all duration-500 ease-in-out"
                />
            </div>
          </div>

          {/* Left Arrow */}
          <div 
            className="hidden group-hover:block absolute top-1/2 -translate-y-1/2 left-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer hover:bg-black/40 transition-all z-10"
            onClick={prevSlide}
          >
            <ChevronLeft size={30} />
          </div>

          {/* Right Arrow */}
          <div 
            className="hidden group-hover:block absolute top-1/2 -translate-y-1/2 right-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer hover:bg-black/40 transition-all z-10"
            onClick={nextSlide}
          >
            <ChevronRight size={30} />
          </div>

          {/* Dots */}
          <div className="flex justify-center py-4 gap-2 mt-4">
            {images.map((_, slideIndex) => (
              <div
                key={slideIndex}
                onClick={() => goToSlide(slideIndex)}
                className={`text-2xl cursor-pointer transition-all duration-300 ${
                  currentIndex === slideIndex ? 'bg-[#0C1D40] w-8' : 'bg-gray-300 w-2'
                } h-2 rounded-full`}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Showcase;
